import * as React from 'react';

import {colors} from 'shells/colors/colors';
// @ts-expect-error - imported from .js/.jsx file
import {UpgradeArrowIcon} from 'shells/icon/svg/upgrade-arrow-icon';

import type {GetSavedFilterCount_savedFilterCount as FormattedValue} from 'nutshell-graphql-types';

import {useGetAudiences} from '../graphql/hooks/use-get-audiences';

import {DEFAULT_GET_AUDIENCE_VARIABLES} from './consts';
import {getNavItemsFromAudiences} from './helpers';
import {SidebarSection} from './sidebar-section';
import type {NavItemObj} from './types';

type Props = {
    searchParams: any;
    listsAreImmutable: boolean;
    onOpenModal: (navItem: NavItemObj) => void;
    searchNameQuery: string | null | undefined;
    selectedCount: FormattedValue | null | undefined;
    shouldShowUpgrade: boolean;
};

export function AudienceSectionWrapper(props: Props) {
    const {audiences, isLoading} = useGetAudiences({
        ...DEFAULT_GET_AUDIENCE_VARIABLES,
        search: props.searchNameQuery,
    });

    const audienceNavItems = getNavItemsFromAudiences(
        audiences,
        props.searchParams,
        props.selectedCount
    );

    return (
        <div>
            <SidebarSection
                header={
                    <div className='flex align-center gap-8'>
                        Audiences
                        {props.shouldShowUpgrade && (
                            <UpgradeArrowIcon
                                size={13}
                                data-tip='Add a Marketing plan to use this feature'
                                data-place='bottom'
                                className='flex align-center'
                                color={colors.black}
                            />
                        )}
                    </div>
                }
                navItems={audienceNavItems}
                isLoading={isLoading}
                onOpenModal={props.onOpenModal}
                listsAreImmutable={props.listsAreImmutable}
                type='audiences'
                entityType='contacts'
                searchNameQuery={props.searchNameQuery}
                searchParams={props.searchParams}
            />
        </div>
    );
}
